angular
    .module('app')
    .component('badges', {
        templateUrl: '/templates/pages/badges/badges.html',
        controller: 'BadgesController',
        controllerAs: 'vm',
    });